import { IABTest } from "./interfaces/abtest.interface";
import { IAnalyticsSystem } from "./interfaces/analytics-system.interface";
import { IQuiz } from '../../interfaces/quiz.interface';
import { IAnalyticsData } from './interfaces/analytics-data.interface';
import { AnalyticsType } from "./enums/analytics-type.enum";
import { YaMetrikaCounter } from "./ya-metrika";
import { GTag } from "./gtag";
import { appConfig } from "../../config/app.config";
import { PostMessageEvent } from "../../enums/post-message-event.enum";
import { QuizEvent } from "../../enums/quiz-event.enum";
import { OwnAnalytics } from './own-analytics';
import { IApiProvider } from '../../interfaces/api-provider.interface';
import { VKPixel } from './vk-pixel';
import { AnalyticsEvent } from "./enums/analytics-event.enum";
import { IModule } from "../../interfaces/module.interface";
import { MailRu } from "./mail_ru";
import { IDebugProvider } from "../../interfaces/debug-provider.interface";
import { IPostMessage } from "../../interfaces/post-message.interface";

export default class Analytics implements IModule {
  constructor(
    private readonly datas: IAnalyticsData[],
    private readonly apiProvider: IApiProvider,
    private readonly debugProvider: IDebugProvider
  ) {
    this.datas.forEach(data => {
      switch (data.type) {
        case AnalyticsType.YA_METRIKA: this.systems.push(new YaMetrikaCounter(Number(data.id), data.bindEventsList, data.prefix, data.options));
          break;
        case AnalyticsType.GA_3: this.systems.push(new GTag(String(data.id), appConfig(), data.bindEventsList));
          break;
        case AnalyticsType.OWN_ANALYTICS: this.systems.push(new OwnAnalytics(String(data.id), this.apiProvider));
          break;
        case AnalyticsType.VK_PIXEL: this.systems.push(new VKPixel(String(data.id)));
          break;
        case AnalyticsType.MAIL_RU: this.systems.push(new MailRu(String(data.id), data.bindEventsList, data.prefix));
          break;
        default: return;
      }
    });
  }

  private systems: IAnalyticsSystem[] = [];
  private quiz: IQuiz;

  public readonly name = "analytics";

  public async getData() {
    return this.datas;
  }

  public init(quiz: IQuiz) {
    this.quiz = quiz;

    this.systems.forEach(system => system.init(quiz));

    this.quiz.bind<IPostMessage<any>>(QuizEvent.RECEIVE_POST_MESSAGE, message => {
      switch (message?.event) {
        case PostMessageEvent.SEND_ANALYTICS:
          this.track(message.data.event, message.data.params);
          this.debugProvider.log("analytics event: ", message.data.event, message.data.params);
          break;

        case PostMessageEvent.SET_ANALYTICS_PARAMS:
          this.setParams(message.data.params);
          break;

        case PostMessageEvent.SET_AB_TEST:
          this.setABTest(message.data);
          break;
      }
    });

    this.apiProvider.getLabels(this.quiz.getState().quizOptions.quizId).then(params => {
      this.setParams(params);
    });
  }

  private track(event: AnalyticsEvent, params?: Record<string, any>) {
    console.log(this.systems);
    this.systems.forEach(system => system.track(event, params));
  }

  private setParams(params: Record<string, any>) {
    this.systems.forEach(system => system.setParams(params))
  }

  private setABTest(abTest: IABTest) {
    this.systems.forEach(system => system.setABTest(abTest));
  }
}